import { render, staticRenderFns } from "./ClientWithoutCallingDetails.vue?vue&type=template&id=ed3eea4e&"
import script from "./ClientWithoutCallingDetails.vue?vue&type=script&lang=js&"
export * from "./ClientWithoutCallingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports